import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-signature-field',
  templateUrl: './signature-field.component.html',
  styleUrls: ['./signature-field.component.scss']
})
export class SignatureFieldComponent implements AfterViewInit, OnChanges {

  @ViewChild('canvasEl') canvasRef!: ElementRef<HTMLCanvasElement>;

  @Input() label = 'Signature';
  @Input() value: string | null = null;
  @Input() disabled = false;
  @Input() required = false;
  @Input() hasError = false;

  @Output() valueChange = new EventEmitter<string>();
  @Output() drawEnd = new EventEmitter<string>();
  @Output() editableState = new EventEmitter<boolean>();

  signaturePad!: SignaturePad;
  isEditable: boolean = true;

  ngAfterViewInit() {
    this.initializePad();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && this.canvasRef) {
      this.renderImage();
    }
  }

  initializePad() {
    const canvas = this.canvasRef.nativeElement;

    this.resizeCanvas();

    this.signaturePad = new SignaturePad(canvas, {
      penColor: 'black',
      backgroundColor: 'rgba(0,0,0,0)'
    });

    canvas.addEventListener('mouseup', () => this.onDrawEnd());
    canvas.addEventListener('touchend', () => this.onDrawEnd());

    if (this.value) {
      this.renderImage();
    }

    this.applyEditableState(!this.disabled);
  }

  resizeCanvas() {
    const canvas = this.canvasRef.nativeElement;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);

    const width = canvas.offsetWidth || 400;
    const height = canvas.offsetHeight || 150;

    canvas.width = width * ratio;
    canvas.height = height * ratio;

    const ctx = canvas.getContext('2d');
    ctx?.scale(ratio, ratio);
  }

  renderImage() {
    const canvas = this.canvasRef.nativeElement;

    if (!this.value) return;

    const img = new Image();
    img.src = this.value;
    img.onload = () => {
      const ctx = canvas.getContext('2d');
      ctx?.drawImage(img, 0, 0, canvas.offsetWidth, canvas.offsetHeight);
    };
  }

  onDrawEnd() {
    if (!this.isEditable || this.signaturePad.isEmpty()) return;
    const data = this.signaturePad.toDataURL();
    this.drawEnd.emit(data);
    this.valueChange.emit(data);
  }

  clear() {
    this.signaturePad.clear();
    const canvas = this.canvasRef.nativeElement;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);  // no background
    }

    this.valueChange.emit('');
  }


  toggleEdit() {
    if (this.disabled) return;

    this.isEditable = !this.isEditable;
    this.applyEditableState(this.isEditable);
  }

  applyEditableState(state: boolean) {
    const canvas = this.canvasRef.nativeElement;

    this.isEditable = state;

    canvas.style.pointerEvents = state ? 'auto' : 'none';
    this.editableState.emit(state);
  }
}
